if (!customElements.get('image-blocks-carousel')) {
  class ImageBlocksCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.resizeTimer = null;
      this.initTimer = null;
    }

    connectedCallback() {
      this.swiperContainer = this.querySelector('.swiper') || this.querySelector('[class*="image-blocks-v2__swiper-"]');
      if (!this.swiperContainer) return;

      this.enableDesktop = this.dataset.enableDesktop === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 2500;
      this.slidesPerViewTablet = parseInt(this.dataset.slidesPerViewTablet, 10) || 2;
      this.paginationElement = this.querySelector('.swiper-pagination') || this.querySelector('[class*="swiper-pagination-"]');
      this.nextButtonElement = this.querySelector('.swiper-button-next') || this.querySelector('[class*="swiper-button-next-"]');
      this.prevButtonElement = this.querySelector('.swiper-button-prev') || this.querySelector('[class*="swiper-button-prev-"]');

      this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');
      this.handleMediaChange = () => this.initOrDestroySwiper();

      if (this.mobileMediaQuery.addEventListener) {
        this.mobileMediaQuery.addEventListener('change', this.handleMediaChange);
      } else if (this.mobileMediaQuery.addListener) {
        this.mobileMediaQuery.addListener(this.handleMediaChange);
      }

      this.handleResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.initOrDestroySwiper(), 150);
      };
      window.addEventListener('resize', this.handleResize);

      this.initOrDestroySwiper();
    }

    disconnectedCallback() {
      if (this.mobileMediaQuery) {
        if (this.mobileMediaQuery.removeEventListener) {
          this.mobileMediaQuery.removeEventListener('change', this.handleMediaChange);
        } else if (this.mobileMediaQuery.removeListener) {
          this.mobileMediaQuery.removeListener(this.handleMediaChange);
        }
      }
      clearTimeout(this.resizeTimer);
      clearTimeout(this.initTimer);
      window.removeEventListener('resize', this.handleResize);
      this.destroySwiper();
    }

    initOrDestroySwiper() {
      const shouldBeActive = this.enableDesktop || this.mobileMediaQuery.matches;

      if (shouldBeActive) {
        if (!this.swiperInstance || this.swiperInstance.destroyed) {
          if (typeof Swiper === 'undefined') {
            clearTimeout(this.initTimer);
            this.initTimer = setTimeout(() => this.initOrDestroySwiper(), 50);
            return;
          }

          this.swiperInstance = new Swiper(this.swiperContainer, {
            direction: 'horizontal',
            loop: true,
            observer: true,
            observeParents: true,
            pagination: this.paginationElement
              ? {
                  el: this.paginationElement,
                  clickable: true,
                }
              : false,
            navigation:
              this.nextButtonElement && this.prevButtonElement
                ? {
                    nextEl: this.nextButtonElement,
                    prevEl: this.prevButtonElement,
                  }
                : false,
            breakpoints: {
              0: { slidesPerView: 1 },
              750: { slidesPerView: this.slidesPerViewTablet },
              769: {
                slidesPerView: this.enableDesktop ? 3.2 : 1,
              },
            },
            autoplay: {
              delay: this.autoplaySpeed,
              disableOnInteraction: true,
            },
          });
        } else {
          this.swiperInstance.update();
        }
      } else {
        this.destroySwiper();
      }
    }

    destroySwiper() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  customElements.define('image-blocks-carousel', ImageBlocksCarousel);
}
